import { supabase } from "../supabase";

let affiliateCodePromise;
let cachedUserId;

const affiliateCodeFor = user => {
  if (!user?.id) return Promise.resolve(null);
  if (!affiliateCodePromise || cachedUserId !== user.id) {
    cachedUserId = user.id;
    affiliateCodePromise = supabase
      .from("affiliates")
      .select("code")
      .eq("user_id", user.id)
      .eq("active", true)
      .maybeSingle()
      .then(({ data, error }) => error ? null : data?.code || null)
      .catch(() => null);
  }
  return affiliateCodePromise;
};

export async function getShareLink(productId, user, origin = window.location.origin) {
  const url = new URL(`/shop/${productId}`, origin);
  const code = await affiliateCodeFor(user);
  if (code) url.searchParams.set("ref", code);
  return url.toString();
}

export function resetShareLinkCache() {
  affiliateCodePromise = undefined;
  cachedUserId = undefined;
}
